/* eslint-disable react/prop-types */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable dot-notation */
/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-unused-state */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
/* eslint-disable quote-props */
/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { Component } from 'react';
import { ToastsContainer, ToastsStore, ToastsContainerPosition } from 'react-toasts';

import axios from 'axios';
import ReactTooltip from 'react-tooltip';
import Aux from '../../../../hoc/Aux';
import ConfigurationScreenContentGenresItem from './ConfigurationScreenContentGenresItem/ConfigurationScreenContentGenresItem';
import GenresDropDownComponent from '../GenresDropDownComponent';
import Classes from '../ConfigurationScreenContent.css';
import config from '../../../../moramma-config.json';
import lang from '../../../../lang.json';

class ConfigurationScreenContentGenres extends Component {
  state = {
    userData: {},
    genres: [],
    selectedGenres: [],
    renderGenres: [],
    availableGenresPicked: 4
  }

  componentWillMount() {
    const localtoken = localStorage.getItem('API');
    if (localtoken) {
      axios({
        method: 'get',
        url: `${config['BASE_API']}/deezer/genres`,
        headers: {
          "Authorization": `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      }).then(items => {
        const genresList = items.data.data;
        //  console.warn(genresList);
        this.setState({ genres: genresList });
      });

      axios({
        method: 'post',
        url: `${config['BASE_API']}/react/user`,
        headers: {
          "Authorization": `Bearer ${localtoken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        data: { token: localtoken }
      }).then(items => {
        if (items.data.data.location.genres) {
          const genresListHtml = items.data.data.location.genres.map((genre) => (
            <ConfigurationScreenContentGenresItem
              key={genre.id}
              name={genre.name}
              picture_small={genre.picture_small}
              fullGenre={genre}
              onRemove={this.genreRemovedFromList}
            />
          ));
          this.setState({ renderGenres: genresListHtml, selectedGenres: items.data.data.location.genres, availableGenresPicked: 4 - items.data.data.location.genres.length });
        }
        
        this.setState({ userData: items.data.data });
      });
    }
  }

  dropDownSelection = (values) => {
    const localtoken = localStorage.getItem('API');
    const selected = values[0];
    const avaiable = this.state.availableGenresPicked;

    if (avaiable <= 0) {
      ToastsStore.error(`You reached the genres limit. Please remove one from the list before.`);
      return;
    }

    if (selected && selected.name === 'All') {
      ToastsStore.warning('Cant add all genres!');
      return;
    }

    const tmpSelectedGenres = this.state.selectedGenres;

    if (tmpSelectedGenres[0]) {
      const index = tmpSelectedGenres.findIndex((el) => el.name === selected.name);
      if (index !== -1) {
        ToastsStore.warning('Already added!');
        return;
      } 
    }

    axios({
      method: 'put',
      url: `${config['BASE_API']}/react/genres`,
      headers: {
        "Authorization": `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: { genre: selected }
    }).then(items => {
      const genresListHtml = items.data.data.location.genres.map((genre) => (
        <ConfigurationScreenContentGenresItem
          key={genre.id}
          name={genre.name}
          picture_small={genre.picture_small}
          fullGenre={genre}
          onRemove={this.genreRemovedFromList}
        />
      ));
      this.setState({ selectedGenres: items.data.data.location.genres, renderGenres: genresListHtml, availableGenresPicked: avaiable - 1 });
    });
  }


  genreRemovedFromList = (genre) => {
    const localtoken = localStorage.getItem('API');
    const avaiable = this.state.availableGenresPicked;

    axios({
      method: 'delete',
      url: `${config['BASE_API']}/react/genres`,
      headers: {
        "Authorization": `Bearer ${localtoken}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      data: { genre: genre }
    }).then(items => {
      if (items.data.data.location.genres) {
        const genresListHtml = items.data.data.location.genres.map((genreItem) => (
          <ConfigurationScreenContentGenresItem
            key={genreItem.id}
            name={genreItem.name}
            picture_small={genreItem.picture_small}
            fullGenre={genreItem}
            onRemove={this.genreRemovedFromList}
          />
        ));
        this.setState({ renderGenres: genresListHtml, selectedGenres: items.data.data.location.genres, availableGenresPicked: avaiable + 1 });
      }
    });
  }

  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${Classes.TitleCard}`}> 
              <div className="row">
                <div className="col-8">
                  <br />
                  <h3> 
                    {lang[this.props.language].confscreen_genres_title_1of2}
                    <br />
                    {lang[this.props.language].confscreen_genres_title_2of2}
                  </h3>
                  <br />
                  <br />
                  <p className={Classes.DescriptionCard}>
                    {lang[this.props.language].confscreen_genres_description}
                  </p>
                </div>
                <div className="col-4 align-self-center">
                  <img src={require('../../../../assets/img/imgGenres.png')} alt="img-psw" className={Classes.MainImage} />
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${Classes.DefCard}`}> 
            
              <div className="row">
                <div className="col-12">
                  <br />
                  <h3> 
                    {lang[this.props.language].confscreen_genres_subtitle}
                    <i data-html="true" data-place="right" data-tip={lang[this.props.language].confscreen_genres_hint} className={`fas fa-question-circle ${Classes.HelpIcon} ${Classes.TxtLeft}`} />
                  </h3>
                  <br />
                  <hr />
                  <p>
                    <b>
                      {lang[this.props.language].confscreen_genres_txt_numb_left}
                        : 
                      {this.state.availableGenresPicked}
                    </b>
                  </p>
                  <p>
                    { 
                      <GenresDropDownComponent
                        options={this.state.genres}
                        placeholder={lang[this.props.language].confscreen_genres_txt_choose_genre}
                        eventChange={this.dropDownSelection}
                      /> 
                    }
                    <br />
                    
                    
                    { this.state.renderGenres.length >= 1 ? (
                      <div>
                        <p>
                          {lang[this.props.language].confscreen_genres_txt_active}
                        :
                        </p>
                        {this.state.renderGenres}
                      </div>
                    ) : (
                      ''
                    ) }
                    <br />
                  </p>
                </div>
              </div>
            </div>
            <div className="col" />
            <ReactTooltip />
          </div>
        </div>
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentGenres;
